import { render, staticRenderFns } from "./CustomerProfile.vue?vue&type=template&id=cb70f016&scoped=true"
import script from "./CustomerProfile.vue?vue&type=script&lang=js"
export * from "./CustomerProfile.vue?vue&type=script&lang=js"
import style0 from "./CustomerProfile.vue?vue&type=style&index=0&id=cb70f016&prod&lang=scss&scoped=true"
import style1 from "./CustomerProfile.vue?vue&type=style&index=1&id=cb70f016&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb70f016",
  null
  
)

export default component.exports